import { FC } from 'react'
import { FormattedValue } from '../hooks/dataFormatter';

export class SinglePrintProps {
    label: string = "";
    data?: string|number;
    isWorkRegimeRow?: boolean = false;
}

const SinglePrint: FC<SinglePrintProps> = (props) => {
    const formatData = (data: string|number) => typeof data == "string" ? formatString(data as string) : formatNumber(data as number);
    const formatString = (data: string) => data;
    const formatNumber = (data: number) => (isNaN(data) || data == null || data == undefined) ? FormattedValue(0) : FormattedValue(data);
    
    return(
        <div className={props.isWorkRegimeRow ? "jour-detail" : "detail-field"}>
            <div className={props.isWorkRegimeRow ? "details-data" : "details-label"}><strong>{props.label}</strong></div>
            { props.data && <div className="details-data">{formatData(props.data)}</div> }
        </div>
    );
}

export { SinglePrint };